import api from './api';

export const getAtsSettings = () => api.get('/v1/ats-settings');
export const updateAtsSettings = (data) => api.put('/v1/ats-settings', data);
